
const STATUS_CONFIG = {
  paid: {
    label: "Paid",
    className: "bg-[#27815C]/10 text-[#27815C]",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    ),
  },
  pending: {
    label: "Pending",
    className: "bg-yellow-50 text-yellow-700",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
      </svg>
    ),
  },
};

function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full ${config.className}`}>
      {config.icon}
      {config.label}
    </span>
  );
}

function OneTimeCharge({ charges }) {
  return (
    <div className="px-5 pb-5">
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-100 bg-gray-50">
              <th className="text-left py-2.5 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Charge
              </th>
              <th className="text-center py-2.5 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="text-center py-2.5 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Paid Date
              </th>
              <th className="text-right py-2.5 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                Amount
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {charges.map((charge) => (
              <tr key={charge.name}>
                <td className="py-3 px-4">
                  <span className="text-sm font-medium text-gray-900">
                    {charge.name}
                  </span>
                </td>
                <td className="py-3 px-4 text-center">
                  <StatusBadge status={charge.status} />
                </td>
                <td className="py-3 px-4 text-center">
                  <span className="text-sm text-gray-600">
                    {charge.paidDate || "—"}
                  </span>
                </td>
                <td className="py-3 px-4 text-right">
                  {charge.originalAmount ? (
                    <div className="flex flex-col items-end">
                      <span className="text-xs text-gray-400 line-through">
                        ${charge.originalAmount.toLocaleString()}
                      </span>
                      <span className="text-sm font-medium text-[#27815C]">
                        ${charge.amount.toLocaleString()}
                      </span>
                    </div>
                  ) : (
                    <span className="text-sm font-medium text-gray-900">
                      ${charge.amount.toLocaleString()}
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-gray-500 flex items-center gap-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" x2="12" y1="8" y2="12" />
          <line x1="12" x2="12.01" y1="16" y2="16" />
        </svg>
        One-time charges are managed in Chargebee and displayed here for reference only.
      </p>
    </div>
  );
}

export default OneTimeCharge;